import styled from "styled-components";
import { COLORS } from "~/src/styles/config.style";

export const StyledBannerContainer = styled.div`
  padding: 24px;
`;

export const StyledMainHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  border-bottom: 1px solid ${({ theme }) => theme.neutral.light};
  border-radius: 0px !important;
  margin-bottom: 20px;
`;

export const StyledMainHeading = styled.p`
  font-size: 16px;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: white;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const StyledTableHeader = styled.th`
  background-color: ${COLORS.MAIN_ORANGE};
  padding: 12px 16px;
  text-align: left;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: normal;
`;

export const StyledTableRow = styled.tr`
  border-bottom: 1px solid #e5e7eb;
`;

export const StyledTableCell = styled.td`
  padding: 12px 16px;
  font-size: 14px;
  color: #374151;

  strong {
    display: block;
    margin-bottom: 4px;
    color: #111827;
  }
`;

export const StyledPlatformBadge = styled.span`
  display: inline-block;
  padding: 2px 8px;
  margin-right: 4px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  background-color: #e5e7eb;
  color: #374151;
  text-transform: uppercase;
`;

export const StyledActionButtons = styled.div`
  display: flex;
  gap: 8px;
`;

export const StyledEmptyState = styled.div`
  text-align: center;
  padding: 60px 20px;
  background: white;
`;

// Modal Styles
export const StyledModalBody = styled.div`
  padding: 24px;
`;

export const StyledModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #e5e7eb;
`;

// Form Styles
export const StyledFormGroup = styled.div`
  margin-bottom: 20px;
`;

export const StyledLabel = styled.label`
  display: block;
  margin-bottom: 6px;
  font-size: 14px;
  line-height: 17px;
  color: rgb(161, 161, 161);
`;

export const StyledCheckboxGroup = styled.div`
  display: flex;
  gap: 16px;
`;

export const StyledCheckbox = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #374151;

  input[type="checkbox"] {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
`;

export const StyledFormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
`;

export const FormGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;

  ${StyledFormGroup} {
    flex: 1;
    min-width: 280px;
    margin-bottom: 0;
  }
`;

export const FullWidthFormGroup = styled(StyledFormGroup)`
  width: 100%;
  margin-bottom: 16px;
`;
